import React, { useEffect, useRef } from "react";
import { global } from "@shared/libs/Global";

type ReportViewerProps = {
  reportName?: string;
  dataJson?: Record<string, any>; // 선택적 JSON 데이터
};

const ReportViewer: React.FC<ReportViewerProps> = ({
  reportName,
  dataJson = {},
}) => {
  const formRef = useRef<HTMLFormElement>(null);
  const { config } = global();

  useEffect(() => {
    if (formRef.current) {
      formRef.current.submit();
    }
  }, [reportName, dataJson]);

  return (
    <div style={{ height: "100vh", width: "100%" }}>
      {/* 숨겨진 폼 - iframe 대상으로 POST 전송 */}
      <form
        ref={formRef}
        method="POST"
        action={`https://${config.SYS0026.dc_ctrl}/viewer`}
        target="reportFrame"
        style={{ display: "none" }}
      >
        <input type="hidden" name="reportName" value={reportName} />
        <input type="hidden" name="dataJson" value={JSON.stringify(dataJson)} />
      </form>

      {/* 리포트를 표시할 iframe */}
      <iframe
        name="reportFrame"
        width="100%"
        height="100%"
        frameBorder={0}
        title="Report Viewer"
      />
    </div>
  );
};

export default ReportViewer;
